/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import type { datadogLogs } from "@datadog/browser-logs";

import type { User } from "@vienna/prisma";

import { parseJwt } from "src/lib/utils/parseJwt";

// Don't initialize if on vercel server
let dLog: typeof datadogLogs;
if (typeof window !== "undefined") {
  dLog = require("@datadog/browser-logs").datadogLogs;
}

export function initDatadog(isScreenshotter: boolean): void {
  // get frontend logs for remote only and disable for screenshots (isScreenshotter true)
  if (process.env.ENVIRONMENT !== "local" && !isScreenshotter) {
    dLog.init({
      clientToken: "pubd7e0b184f5bc7b9a29d3f7ba75e6d28b",
      forwardErrorsToLogs: true,
      sampleRate: 100,
      service: "client",
      forwardConsoleLogs: "all", // send all logs to dd, not just level=error
      env: process.env.ENVIRONMENT,
      beforeSend: (log) => {
        const userInfo = parseJwt(localStorage.getItem("token") || "{}") as Partial<User>;
        if (!userInfo) return;
        log.userId = userInfo.id;
        log.username = userInfo.username;
      },
    });
  }
}

export const clientLogger = typeof window === "undefined" ? console : dLog!.logger;
